import { DefenceType } from "../../models/enums";

export const armourByDefenceType: { defenceType: DefenceType, items: string[] }[] = [
  {
    "defenceType": DefenceType.Armour,
    "items": [
      "Ancestor Tower Shield",
      "Ancient Mitts",
      "Barricade Tower Shield",
      "Bolstered Mitts",
      "Braced Tower Shield",
      "Bronze Greaves",
      "Bulwark Greaves",
      "Bulwark Tower Shield",
      "Carved Greaves",
      "Chieftain Cuirass",
      "Commander Greathelm",
      "Crucible Tower Shield",
      "Detailed Mitts",
      "Effigial Tower Shield",
      "Elegant Greathelm",
      "Elegant Greaves",
      "Elegant Plate",
      "Elite Greathelm",
      "Feathered Mitts",
      "Fierce Greathelm",
      "Fortress Tower Shield",
      "Full Plate",
      "Fur Plate",
      "Goldworked Tower Shield",
      "Heavy Plate",
      "Heraldric Tower Shield",
      "Imperial Greathelm",
      "Iron Cuirass",
      "Iron Greaves",
      "Juggernaut Plate",
      "Knightly Mitts",
      "Maraketh Cuirass",
      "Masked Greathelm",
      "Massive Mitts",
      "Moulded Mitts",
      "Noble Greathelm",
      "Noble Tower Shield",
      "Ornate Greaves",
      "Ornate Mitts",
      "Ornate Plate",
      "Painted Tower Shield",
      "Paragon Greathelm",
      "Raider Plate",
      "Rampart Tower Shield",
      "Reefsteel Greaves",
      "Riveted Mitts",
      "Rough Greaves",
      "Royal Tower Shield",
      "Rusted Cuirass",
      "Rusted Greathelm",
      "Soldier Cuirass",
      "Soldier Greathelm",
      "Spired Greathelm",
      "Splintered Tower Shield",
      "Steel Plate",
      "Stocky Mitts",
      "Stone Cuirass",
      "Stone Greaves",
      "Stone Tower Shield",
      "Tasalian Greaves",
      "Tawhoan Tower Shield",
      "Tempered Mitts",
      "Trimmed Greaves",
      "Utzaal Cuirass",
      "Vaal Cuirass",
      "Vaal Greaves",
      "Vaal Mitts",
      "Vaal Tower Shield",
      "Warlord Cuirass",
      "Warmonger Greathelm",
      "Warrior Greathelm",
      "Wrapped Greathelm"
    ]
  },
  {
    "defenceType": DefenceType.Evasion,
    "items": [
      "Ancient Buckler",
      "Barbed Bracers",
      "Bladeguard Buckler",
      "Bound Bracers",
      "Cavalry Boots",
      "Cinched Boots",
      "Corsair Cap",
      "Corsair Coat",
      "Corsair Vest",
      "Deerstalker Hood",
      "Desert Buckler",
      "Desert Cap",
      "Dragonscale Boots",
      "Drakeskin Boots",
      "Edged Buckler",
      "Embossed Boots",
      "Felt Cap",
      "Fine Bracers",
      "Firm Bracers",
      "Flared Boots",
      "Freebooter Cap",
      "Grand Bracers",
      "Gutspike Buckler",
      "Hunter Hood",
      "Iron Buckler",
      "Jingling Buckler",
      "Lace Hood",
      "Laced Boots",
      "Laminate Buckler",
      "Layered Vest",
      "Leather Buckler",
      "Leather Vest",
      "Leatherbound Hood",
      "Lizardscale Boots",
      "Lizardscale Coat",
      "Ornate Buckler",
      "Pathfinder Coat",
      "Pearl Buckler",
      "Plated Buckler",
      "Polished Bracers",
      "Quilted Vest",
      "Rawhide Boots",
      "Refined Bracers",
      "Rhoahide Coat",
      "Ridged Buckler",
      "Ringed Buckler",
      "Runner Vest",
      "Scout's Vest",
      "Sectioned Bracers",
      "Serpentscale Boots",
      "Serpentscale Coat",
      "Shabby Hood",
      "Shrouded Vest",
      "Slipstrike Vest",
      "Smuggler Coat",
      "Spiked Bracers",
      "Spiked Buckler",
      "Spikeward Buckler",
      "Spined Bracers",
      "Stalking Bracers",
      "Steeltoe Boots",
      "Studded Boots",
      "Studded Vest",
      "Suede Bracers",
      "Swathed Cap",
      "Swiftstalker Coat",
      "Trapper Hood",
      "Viper Cap",
      "Wooden Buckler",
      "Woven Cap",
      "Wrapped Cap",
      "Wyrmscale Coat"
    ]
  },
  {
    "defenceType": DefenceType.EnergyShield,
    "items": [
      "Adherent's Raiment",
      "Altar Robe",
      "Ancestral Tiara",
      "Antler Focus",
      "Arrayed Focus",
      "Baroque Gloves",
      "Beaded Circlet",
      "Bone Raiment",
      "Bound Sandals",
      "Ceremonial Robe",
      "Chain Tiara",
      "Crystal Focus",
      "Cultist Focus",
      "Druidic Focus",
      "Dunerunner Sandals",
      "Elegant Slippers",
      "Elementalist Robe",
      "Engraved Focus",
      "Feathered Raiment",
      "Feathered Robe",
      "Feathered Sandals",
      "Feathered Tiara",
      "Flax Sandals",
      "Flowing Raiment",
      "Gold Circlet",
      "Gold Gloves",
      "Grim Gloves",
      "Hallowed Focus",
      "Hexer's Robe",
      "Intricate Gloves",
      "Jade Tiara",
      "Jewelled Gloves",
      "Jungle Tiara",
      "Kamasan Tiara",
      "Keth Raiment",
      "Lattice Sandals",
      "Leyline Focus",
      "Luxurious Slippers",
      "Mystic Raiment",
      "Opulent Gloves",
      "Pauascale Gloves",
      "Plumed Focus",
      "River Raiment",
      "Runed Focus",
      "Sacramental Robe",
      "Sacred Focus",
      "Sandsworn Sandals",
      "Sandsworn Tiara",
      "Sekhema Sandals",
      "Silk Robe",
      "Silk Slippers",
      "Sirenscale Gloves",
      "Skycrown Tiara",
      "Sombre Gloves",
      "Sorcerous Tiara",
      "Stitched Gloves",
      "Straw Sandals",
      "Tasalian Focus",
      "Tattered Robe",
      "Tonal Focus",
      "Torn Gloves",
      "Twig Circlet",
      "Twig Focus",
      "Vaal Gloves",
      "Vermeil Circlet",
      "Vile Robe",
      "Voodoo Focus",
      "Votive Raiment",
      "Whorl Focus",
      "Wicker Tiara",
      "Woven Focus",
      "Wrapped Sandals"
    ]
  },
  {
    "defenceType": DefenceType.ArmourEvasion,
    "items": [
      "Ancestral Mail",
      "Avian Targe",
      "Baroque Targe",
      "Bastion Sabatons",
      "Blacksteel Gauntlets",
      "Blacksteel Sabatons",
      "Braced Sabatons",
      "Brimmed Helm",
      "Cabalist Helm",
      "Carved Targe",
      "Cassis Helm",
      "Chain Mail",
      "Champion Helm",
      "Chiseled Targe",
      "Cloaked Mail",
      "Closed Helm",
      "Commander Gauntlets",
      "Covered Sabatons",
      "Cowled Helm",
      "Crescent Targe",
      "Cryptic Helm",
      "Cultist Gauntlets",
      "Dastard Armour",
      "Death Mail",
      "Doubled Gauntlets",
      "Explorer Armour",
      "Feathered Targe",
      "Fortress Sabatons",
      "Gladiatorial Helm",
      "Golden Mail",
      "Golden Targe",
      "Guarded Helm",
      "Hardwood Targe",
      "Knight Armour",
      "Layered Gauntlets",
      "Mail Sabatons",
      "Mammoth Targe",
      "Mantled Mail",
      "Noble Sabatons",
      "Pelage Targe",
      "Plate Gauntlets",
      "Polished Targe",
      "Ringmail Gauntlets",
      "Rogue Armour",
      "Scale Mail",
      "Shielded Helm",
      "Shrouded Mail",
      "Soaring Targe",
      "Stacked Sabatons",
      "Steelmail Gauntlets",
      "Stone Targe",
      "Stratified Targe",
      "Studded Targe",
      "Thane Mail",
      "Trailblazer Armour",
      "Vagabond Armour",
      "Veteran Sabatons",
      "Visored Helm",
      "Warded Helm",
      "Zealot Gauntlets"
    ]
  },
  {
    "defenceType": DefenceType.ArmourEnergyShield,
    "items": [
      "Adherent Cuffs",
      "Aged Cuffs",
      "Ancient Cuffs",
      "Apostle Leggings",
      "Blacksteel Crest Shield",
      "Blazon Crest Shield",
      "Bound Cuffs",
      "Cleric Vestments",
      "Conjurer Mantle",
      "Cryptic Crown",
      "Cryptic Leggings",
      "Cultist Crown",
      "Death Mantle",
      "Dekharan Crest Shield",
      "Divine Crown",
      "Druidic Crown",
      "Emblem Crest Shield",
      "Faithful Leggings",
      "Gleaming Cuffs",
      "Glowering Crest Shield",
      "Goldcast Cuffs",
      "Hallowed Crown",
      "Heartcarver Mantle",
      "Heavy Crown",
      "Horned Crown",
      "Inquisitor Crown",
      "Intricate Crest Shield",
      "Iron Crown",
      "Ironclad Vestments",
      "Jingling Crest Shield",
      "Kalguuran Cuffs",
      "Mail Vestments",
      "Martyr Crown",
      "Occultist Mantle",
      "Omen Crest Shield",
      "Ornate Cuffs",
      "Padded Leggings",
      "Pelt Leggings",
      "Pelt Mantle",
      "Pilgrim Vestments",
      "Plated Vestments",
      "Quartered Crest Shield",
      "Righteous Cuffs",
      "Rope Cuffs",
      "Sacrificial Mantle",
      "Saintly Crown",
      "Seastorm Mantle",
      "Sectarian Crest Shield",
      "Secured Leggings",
      "Seer Crest Shield",
      "Sekheman Crest Shield",
      "Shaman Mantle",
      "Shamanistic Leggings",
      "Sigil Crest Shield",
      "Spiritbone Crown",
      "Tideseer Mantle",
      "Vaal Crest Shield",
      "Warlock Leggings",
      "Wayward Crest Shield",
      "Weaver Leggings",
      "Wolfskin Mantle"
    ]
  },
  {
    "defenceType": DefenceType.EvasionEnergyShield,
    "items": [
      "Adorned Wraps",
      "Anchorite Garb",
      "Austere Garb",
      "Avian Mask",
      "Brigand Mask",
      "Buckled Wraps",
      "Charmed Shoes",
      "Daggerfoot Shoes",
      "Elegant Wraps",
      "Face Mask",
      "Falconer's Jacket",
      "Faridun Mask",
      "Frayed Shoes",
      "Gauze Wraps",
      "Grinning Mask",
      "Hatungo Garb",
      "Hawker's Jacket",
      "Hermit Garb",
      "Hewn Mask",
      "Hooded Mask",
      "Hunting Shoes",
      "Itinerant Jacket",
      "Linen Wraps",
      "Marabout Garb",
      "Pariah Mask",
      "Quickslip Shoes",
      "Rambler Jacket",
      "Scalper's Jacket",
      "Scoundrel Jacket",
      "Secured Wraps",
      "Sleek Jacket",
      "Soaring Mask",
      "Solid Mask",
      "Spiral Wraps",
      "Steelpoint Shoes",
      "Threaded Shoes",
      "Treerunner Shoes",
      "Tribal Mask",
      "Vaal Wraps",
      "Veiled Mask",
      "Wanderer Shoes",
      "War Wraps",
      "Waxed Jacket",
      "Wayfarer Jacket"
    ]
  }
];
